import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Centralized status color utilities for consistency across the app
export type TaskStatus = "Backlog" | "Not Started" | "In Progress" | "Done" | "Quality Check";
export type ProjectStatus = string;

// Badge colors for task/project status badges
export function getStatusBadgeColor(status: TaskStatus | ProjectStatus): string {
  switch (status) {
    case "Backlog":
      return "bg-slate-100 text-slate-800 dark:bg-slate-900/30 dark:text-slate-400 border-slate-200 dark:border-slate-700";
    case "Not Started":
      return "bg-gray-100 text-gray-800 dark:bg-gray-900/30 dark:text-gray-400 border-gray-200 dark:border-gray-700";
    case "In Progress":
      return "bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400 border-blue-200 dark:border-blue-700";
    case "Quality Check":
      return "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400 border-yellow-200 dark:border-yellow-700";
    case "Completed":
    case "Done":
      return "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400 border-green-200 dark:border-green-700";
    default:
      return "bg-gray-100 text-gray-800 dark:bg-gray-900/30 dark:text-gray-400 border-gray-200 dark:border-gray-700";
  }
}

// Border colors for task cards and containers  
export function getStatusBorderColor(status: TaskStatus | ProjectStatus): string {
  switch (status) {
    case "Backlog":
      return "bg-slate-500/10 text-slate-500 border-slate-500/20";
    case "Not Started":
      return "bg-muted text-muted-foreground border-border";
    case "In Progress":
      return "bg-blue-500/10 text-blue-500 border-blue-500/20";
    case "Quality Check":
      return "bg-amber-500/10 text-amber-500 border-amber-500/20";
    case "Completed":
    case "Done":
      return "bg-green-500/10 text-green-500 border-green-500/20";
    default:
      return "bg-muted text-muted-foreground border-border";
  }
}

// Badge variant for shadcn/ui Badge components
export function getStatusBadgeVariant(status: TaskStatus | ProjectStatus): "default" | "secondary" | "destructive" | "outline" {
  switch (status) {
    case "In Progress":
      return "default";
    case "Completed":
    case "Done":
      return "secondary";
    case "Quality Check":
      return "outline";
    default:
      return "secondary";
  }
}
